export function imagesToBase64(images: ImageData[]): string[] {
  return images.map((image) => {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;

    canvas.getContext("2d")?.putImageData(image, 0, 0);

    return canvas.toDataURL("image/jpeg", 1.0);
  });
}
